module.exports = __webpack_public_path__ + "55736fa2ce5f24c03a678d679fa12ebb.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/icons/substract.png
// module id = VUR6
// module chunks = 0